


























import { Vue, Component, Prop } from "vue-property-decorator";
import BaseComponent from "@/asdcom/BaseComponent";
import TableComponent from "@/components/vcponlineok/staff-user/table-component/table-component.vue";
import ClaimUpdateRequestComponent from "@/components/vcponlineok/staff-user/claim-update-request-component.vue";
import ClaimLogComponent from "@/components/vcponlineok/staff-user/claim-log-component.vue";
import ApplicantRequestComponent from "@/components/vcponlineok/staff-user/applicant-request-component.vue";
import NewLogEntryComponent from "@/components/vcponlineok/staff-user/new-log-entry-component.vue";
import bus from "@/components/vcponlineok/bus/bus.js";
import { IHeader } from "@/store/models/staff/IHeader";

@Component({
  components: {
    TableComponent,
    ClaimUpdateRequestComponent,
    ClaimLogComponent,
    ApplicantRequestComponent,
    NewLogEntryComponent
  }
})
export default class MasterDetailsComponent extends BaseComponent {
  loading: boolean = false;
  isItemView: boolean = false;
  columnSize: number = 12;
  
  @Prop({ default: [] }) headers: any[];
  // @Prop({default: []}) data: any[];
  @Prop({}) component: string;
  
  @Prop({ default:() => {return []} })
  tableData: any[];
  
  componentModel: any = {};

  get mobileBreakpoint() {
    if (this.isItemView) {
      return 3000;
    } else {
      return 100;
    }
  }

  get componentName() {
    return this.component;
  }

  onClickTableRow(item: any) {

    this.componentModel = this.tableData.find(i => i.itemId == item.itemId);
    abp.log.debug({"master-details-component componentModel":this.componentModel});
    // if (this.$route.params.id !== item.id) {
    //   this.$router.push({ params: { id: item.id } });
    // }
    this.columnSize = 4;
    this.isItemView = true;
  }

  closeItemView() {
    this.columnSize = 12;
    this.isItemView = false;
    // this.$router.push({ name: "UpdateRequests" });
    this.$emit("refreshList");
    this.componentModel = {};
  }
}
